import React from 'react';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { AudienceSection } from '../components/AudienceSection';
import { BetaSection } from '../components/BetaSection';
import { SignupForm } from '../components/SignupForm';
import { Footer } from '../components/Footer';
export function WelmaLanding() {
  return <div className="min-h-screen bg-[#FAFAF8] text-[#2D2D2D] font-sans selection:bg-[#8B9D83]/20" data-id="element-104">
      <main data-id="element-105">
        <Hero data-id="element-106" />
        <PainSection data-id="element-107" />
        <FeaturesSection data-id="element-108" />
        <AudienceSection data-id="element-109" />
        <BetaSection data-id="element-110" />
        <SignupForm data-id="element-111" />
      </main>
      <Footer data-id="element-112" />
    </div>;
}